<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="23.818" height="19" viewBox="0 0 23.818 19">
    <g transform="translate(-199.5 -306.5)">
      <path class="a" d="M0,5.66,2.83,2.83,0,0" transform="translate(219.738 313.34)"/>
      <g transform="translate(-5.266 256.9)">
        <path class="b"
              d="M218.266,52.1h-10a1,1,0,0,0-1,1v12a1,1,0,0,0,1,1h10a1,1,0,0,0,1-1v-12A1,1,0,0,0,218.266,52.1Zm-10-2a3,3,0,0,0-3,3v12a3,3,0,0,0,3,3h10a3,3,0,0,0,3-3v-12a3,3,0,0,0-3-3Z"/>
        <path class="c" d="M210.266,54.1h6a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h-6a1,1,0,0,1-1-1h0A1,1,0,0,1,210.266,54.1Z"/>
        <path class="c" d="M210.266,58.1h6a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h-6a1,1,0,0,1-1-1h0A1,1,0,0,1,210.266,58.1Z"/>
        <path class="c" d="M210.266,62.1h6a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1h-6a1,1,0,0,1-1-1h0A1,1,0,0,1,210.266,62.1Z"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "LeadTakerIcon"
}
</script>

<style scoped>
.a {
  fill: none;
  stroke: #3e4041;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.5px;
}

.b, .c {
  fill: #3e4041;
  stroke: #dcf0e7;
}

.b {
  fill-rule: evenodd;
}

.c {
  stroke-width: 0.5px;
}
</style>
